import React from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import logoDark from '@assets/logos/logo.svg';
import logoLight from '@assets/logos/logo-white.svg';

interface BrandLogoProps {
    /** Alto del monograma en px. */
    size?: number;
    /** Acompañar el monograma con la palabra KABANDU. */
    showName?: boolean;
    justify?: 'flex-start' | 'center';
}

/**
 * Lockup de marca: el monograma (que es casi cuadrado, no un wordmark) más la palabra
 * KABANDU en mayúsculas espaciadas. El archivo se elige por el modo del tema porque el
 * SVG trae su color fijo.
 */
export const BrandLogo: React.FC<BrandLogoProps> = ({ size = 32, showName = true, justify = 'flex-start' }) => {
    const theme = useTheme();
    const src = theme.palette.mode === 'dark' ? logoLight : logoDark;

    return (
        <Stack direction="row" spacing={1.25} alignItems="center" justifyContent={justify}>
            <Box component="img" src={src} alt="Kabandu" sx={{ height: size, width: 'auto', display: 'block' }} />
            {showName && (
                <Typography
                    component="span"
                    sx={{
                        fontSize: size * 0.5,
                        fontWeight: 700,
                        letterSpacing: '0.18em',
                        lineHeight: 1,
                        color: 'text.primary'
                    }}
                >
                    KABANDU
                </Typography>
            )}
        </Stack>
    );
};

export default BrandLogo;
